<template>
  <div class="registration-apply" v-loading="loading">
    <div class="page-title">报名信息</div>

    <div class="apply-card">
      <div
        v-for="field in infoFields"
        :key="field.key"
        class="form-row form-row--input"
      >
        <div class="form-label">
          <span class="required">*</span>
          <span>{{ field.label }}</span>
        </div>
        <div class="form-value form-value--input">
          <el-input
            :value="getInfoFieldValue(field.key)"
            @input="setInfoFieldValue(field.key, $event)"
            :placeholder="field.placeholder"
            maxlength="5"
          >
            <template slot="append">{{ field.suffix }}</template>
          </el-input>
          <div v-if="field.tip" class="form-tip">
            {{ field.tip }}
          </div>
        </div>
      </div>

      <div
        v-for="material in materialSections"
        :key="material.key"
        class="form-row"
      >
        <div class="form-label">
          <span class="required">*</span>
          <span v-html="material.label"></span>
        </div>
        <div class="form-value">
          <el-upload
            class="apply-uploader"
            action="/file/importPicture"
            :http-request="params => uploadMaterial(material.key, params)"
            accept="image/*"
            name="pictureFile"
            :show-file-list="false"
            :disabled="uploading || submitting"
            :on-error="handleUploadError"
          >
            <img
              v-if="material.url"
              :src="material.url"
              class="preview-pic"
            />
            <img
              v-else
              class="uploader-bg"
              :src="material.placeholder"
            />
          </el-upload>
          <div v-if="material.uploading" class="upload-hint">
            {{ material.uploadingText }}
          </div>
        </div>
      </div>

      <div class="submit-wrap">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="submitting"
          :disabled="submitting || uploading"
          @click="submitApply"
        >
          提交审核
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "RegistrationApply",
  data() {
    return {
      loading: false,
      submitting: false,
      applicationFormUrl: "",
      primaryCertiUrl: "",
      piccWorkYear: "",
      monthPiccNum: "",
      uploadingApplicationForm: false,
      uploadingPrimaryCerti: false,
      userInfo: null,
      requirement: {
        requireApplicationForm: false,
        requirePrimaryCerti: false,
        requirePiccWorkYear: false,
        requireMonthPiccNum: false,
        firstApplyInMajorType: false
      }
    };
  },
  computed: {
    erId() {
      const value = Number(this.$route.query.erId);
      if (Number.isNaN(value) || value <= 0) {
        return null;
      }
      return value;
    },
    uploading() {
      return this.uploadingApplicationForm || this.uploadingPrimaryCerti;
    },
    infoFields() {
      const fields = [];
      if (this.requirement.requirePiccWorkYear) {
        fields.push({
          key: "piccWorkYear",
          label: "PICC工作年限",
          placeholder: "请输入PICC工作年限",
          suffix: "年",
          tip: "PICC工作年限需2年及以上"
        });
      }
      if (this.requirement.requireMonthPiccNum) {
        fields.push({
          key: "monthPiccNum",
          label: "PICC植入套数",
          placeholder: "请输入每月PICC植入套数",
          suffix: "套/月",
          tip: "PICC植入套数需10套及以上"
        });
      }
      return fields;
    },
    materialSections() {
      const sections = [];
      if (this.requirement.requireApplicationForm) {
        sections.push({
          key: "applicationFormUrl",
          label: "山东省护士<br />岗位培训申请表<br />照片",
          url: this.applicationFormUrl,
          uploading: this.uploadingApplicationForm,
          uploadingText: "岗位培训申请表上传中...",
          placeholder: require("@/assets/realname/apply_bg.png")
        });
      }
      if (this.requirement.requirePrimaryCerti) {
        sections.push({
          key: "primaryCertiUrl",
          label: "PICC初级证书",
          url: this.primaryCertiUrl,
          uploading: this.uploadingPrimaryCerti,
          uploadingText: "PICC初级证书上传中...",
          placeholder: require("@/assets/realname/pre_cert_bg.png")
        });
      }
      return sections;
    }
  },
  created() {
    this.initPage();
  },
  methods: {
    async loadUserInfo({ silent = false } = {}) {
      try {
        const res = await httpRequest("/app/user", "get", null);
        if (res && res.code === 200) {
          this.userInfo = res.data || null;
          localStorage.setItem("pc_user", JSON.stringify(res.data || {}));
          return true;
        }
      } catch (error) {
        if (!silent) {
          this.$message.warning("获取用户信息失败，请稍后重试");
        }
      }
      return false;
    },
    async ensureRealNamePassed() {
      const loaded = await this.loadUserInfo();
      if (!loaded || !this.userInfo) {
        this.$message.warning("请先登录");
        this.$router.replace("/login");
        return false;
      }
      if (Number(this.userInfo.authStatus) !== 2) {
        this.$message.warning("请先完成实名认证");
        this.$router.replace({
          path: "/registrationDetails",
          query: {
            erId: this.erId,
            isXQ: 0
          }
        });
        return false;
      }
      return true;
    },
    async initPage() {
      if (!this.erId) {
        this.$message.error("参数异常，请重新进入");
        this.$router.replace("/");
        return;
      }
      const passed = await this.ensureRealNamePassed();
      if (!passed) {
        return;
      }
      this.loading = true;
      try {
        const [detailRes, requirementRes] = await Promise.all([
          httpRequest("/app/exam/exam/userExamInfo", "get", {
            erId: this.erId
          }),
          httpRequest("/app/exam/enroll-material-requirement", "get", {
            erId: this.erId
          })
        ]);

        if (detailRes && detailRes.code === 200 && detailRes.data && detailRes.data.enrollCheck) {
          this.applicationFormUrl = detailRes.data.enrollCheck.applicationFormUrl || "";
          this.primaryCertiUrl = detailRes.data.enrollCheck.primaryCertiUrl || "";
          this.piccWorkYear = detailRes.data.enrollCheck.piccWorkYear !== null && detailRes.data.enrollCheck.piccWorkYear !== undefined
            ? String(detailRes.data.enrollCheck.piccWorkYear)
            : "";
          this.monthPiccNum = detailRes.data.enrollCheck.monthPiccNum !== null && detailRes.data.enrollCheck.monthPiccNum !== undefined
            ? String(detailRes.data.enrollCheck.monthPiccNum)
            : "";
        }

        if (requirementRes && requirementRes.code === 200 && requirementRes.data) {
          this.requirement = {
            requireApplicationForm: Boolean(requirementRes.data.requireApplicationForm),
            requirePrimaryCerti: Boolean(requirementRes.data.requirePrimaryCerti),
            requirePiccWorkYear: Boolean(requirementRes.data.requirePiccWorkYear),
            requireMonthPiccNum: Boolean(requirementRes.data.requireMonthPiccNum),
            firstApplyInMajorType: Boolean(requirementRes.data.firstApplyInMajorType)
          };
        }

        if (!this.requirement.requireApplicationForm && !this.requirement.requirePrimaryCerti &&
          !this.requirement.requirePiccWorkYear && !this.requirement.requireMonthPiccNum) {
          this.$message.warning("当前报名无需补充审核资料，请直接进入缴费流程");
          this.$router.replace({
            path: "/registrationDetails",
            query: {
              erId: this.erId,
              isXQ: 0
            }
          });
        }
      } finally {
        this.loading = false;
      }
    },
    handleUploadError() {
      this.$message.error("上传失败，请重试");
      this.uploadingApplicationForm = false;
      this.uploadingPrimaryCerti = false;
    },
    setMaterialUrl(key, value) {
      if (key === "applicationFormUrl") {
        this.applicationFormUrl = value;
      } else if (key === "primaryCertiUrl") {
        this.primaryCertiUrl = value;
      }
    },
    setUploading(key, uploading) {
      if (key === "applicationFormUrl") {
        this.uploadingApplicationForm = uploading;
      } else if (key === "primaryCertiUrl") {
        this.uploadingPrimaryCerti = uploading;
      }
    },
    getInfoFieldValue(key) {
      if (key === "piccWorkYear") return this.piccWorkYear;
      if (key === "monthPiccNum") return this.monthPiccNum;
      return "";
    },
    setInfoFieldValue(key, value) {
      const normalized = String(value || "").replace(/[^\d]/g, "");
      if (key === "piccWorkYear") {
        this.piccWorkYear = normalized;
      } else if (key === "monthPiccNum") {
        this.monthPiccNum = normalized;
      }
    },
    async uploadMaterial(key, params) {
      this.setUploading(key, true);
      const localPreviewUrl = URL.createObjectURL(params.file);
      this.setMaterialUrl(key, localPreviewUrl);
      try {
        const formData = new FormData();
        formData.append(params.filename, params.file);
        const res = await httpRequest(params.action, "post", formData);
        if (res && res.code === 200 && Array.isArray(res.data) && res.data[0]) {
          this.setMaterialUrl(key, res.data[0]);
          this.$message.success("上传成功");
        } else {
          this.setMaterialUrl(key, "");
          this.$message.error("上传失败，请重试");
        }
      } catch (error) {
        this.setMaterialUrl(key, "");
        this.$message.error("上传失败，请重试");
      } finally {
        this.setUploading(key, false);
      }
    },
    async submitApply() {
      if (!this.erId) {
        this.$message.error("参数异常，请重新进入");
        return;
      }
      const passed = await this.ensureRealNamePassed();
      if (!passed) {
        return;
      }
      if (this.requirement.requireApplicationForm && !this.applicationFormUrl) {
        this.$message.warning("请先上传岗位培训申请表照片");
        return;
      }
      if (this.requirement.requirePrimaryCerti && !this.primaryCertiUrl) {
        this.$message.warning("请先上传PICC初级证书");
        return;
      }
      if (this.requirement.requirePiccWorkYear && !/^[0-9]+$/.test(this.piccWorkYear || "")) {
        this.$message.warning("请填写整数形式的PICC工作年限");
        return;
      }
      if (this.requirement.requirePiccWorkYear && Number(this.piccWorkYear) < 2) {
        this.$message.warning("PICC工作年限需2年及以上");
        return;
      }
      if (this.requirement.requireMonthPiccNum && !/^[0-9]+$/.test(this.monthPiccNum || "")) {
        this.$message.warning("请填写整数形式的PICC植入套数");
        return;
      }
      if (this.requirement.requireMonthPiccNum && Number(this.monthPiccNum) < 10) {
        this.$message.warning("PICC植入套数需10套及以上");
        return;
      }
      this.submitting = true;
      try {
        const payload = {
          erId: this.erId,
          applicationFormUrl: this.applicationFormUrl,
          primaryCertiUrl: this.primaryCertiUrl
        };
        if (this.requirement.requirePiccWorkYear) {
          payload.piccWorkYear = Number(this.piccWorkYear);
        }
        if (this.requirement.requireMonthPiccNum) {
          payload.monthPiccNum = Number(this.monthPiccNum);
        }
        const res = await httpRequest("/app/exam/enroll-check", "post", payload);
        if (res && res.code === 200) {
          this.$message.success("提交审核成功");
          this.$router.replace("/");
        }
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.registration-apply {
  width: 1200px;
  margin: 18px auto 0;
  min-height: calc(100vh - 77px - 100px - 18px);
  padding-bottom: 30px;

  .page-title {
    height: 68px;
    line-height: 68px;
    background: #4095e5;
    color: #ffffff;
    font-size: 36px;
    font-weight: 500;
    text-align: center;
    border-radius: 6px 6px 0 0;
    margin-bottom: 0;
  }

  .apply-card {
    background: #ffffff;
    border: 1px solid #e9edf4;
    border-top: none;
    padding: 26px 40px 40px;
    min-height: 430px;
  }

  .form-row {
    display: flex;
    align-items: flex-start;
    padding-top: 4px;

    & + .form-row {
      margin-top: 22px;
    }
  }

  .form-label {
    width: 120px;
    color: #5e6673;
    line-height: 1.8;
    font-size: 14px;
    display: flex;
    align-items: flex-start;

    .required {
      color: #f56c6c;
      margin-right: 2px;
    }
  }

  .form-value {
    margin-left: 0;
  }

  .form-row--input {
    align-items: center;
  }

  .form-value--input {
    width: 360px;
  }

  .form-tip {
    margin-top: 8px;
    text-align: left;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }

  .apply-uploader {
    width: 370px;
    height: 270px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px dashed #d7e0ee;
    cursor: pointer;

    ::v-deep .el-upload {
      width: 100%;
      height: 100%;
      display: block;
    }

    .uploader-bg,
    .preview-pic {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .upload-hint {
    margin-top: 10px;
    color: #f59e0b;
    font-size: 13px;
  }

  .submit-wrap {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .submit-btn {
    width: 380px;
    height: 44px;
    font-size: 16px;
    border-radius: 4px;
    background: #0f63bd;
    border-color: #0f63bd;
  }
}
</style>
